import React,{useEffect,useState} from "react";
import { Button} from "react-bootstrap";
import {Link, useParams} from "react-router-dom";
import styled from "styled-components";
import { getForIndividualsPara } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import CustomTable from "../../Common/DataTable/DataTable";


export default function ViewPara() {
    const {id, partnerId } = useParams();
    const [isLoading, setIsLoading] = useState(true);
 const [data, setPara]  = useState ({
  paragraph: "",
  headerImage: "",
  index: null,
});

  useEffect(() => {
    const fetchParagraphData = async () => {
      setIsLoading(true);
      if (!Number(id)) {
        setIsLoading(false);
        return;
      }

      try {
        const res = await getForIndividualsPara(id);
        console.log(res);
        const paraData = res.data.data[0];
        setPara({ ...paraData, index: res.data.data.indexOf(paraData) });             
        console.log(paraData.headerImage);                     
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchParagraphData();
  }, [id]);

  const columns = ["Paragraph", "Header Image"];
  const rows = [];
  if (data.paragraph) {
    rows.push([data.paragraph, data.headerImage && <img src={data.headerImage} alt="headerImage" width="650" height="250" />]);
  }
  return (
    <>
    {isLoading ? <CmsCircularProgress/> : <ContentWrapper>
      <HomeTitle>Header Section</HomeTitle>
      <CustomTable columns={columns} rows={rows} isLoading={isLoading}/>
      <ButtonWrapper>
        <Link to={`/${partnerId}/forindividuals`}>
          <Button variant="secondary">Go Back</Button>
        </Link>
        
        <Link to={`/${partnerId}/forindividuals/para/edit/${id}`}>
          <Button>{Number(id) ? 'Edit' : 'Add'} header section</Button>
        </Link>
      </ButtonWrapper>
    </ContentWrapper>}
    </>
    
  );
}

const ContentWrapper = styled.div`
  @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const TableWrapper = styled.div`
  margin: 0 auto;
  overflow-x: auto;
`;

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
`;

const TableHeader = styled.th`
  text-align: left;
  padding: 10px;
  border: 2px solid #ccc;
`;

const TableBody = styled.tbody``;

const TableCell = styled.td`
  padding: 10px;
  border: 1px solid #ddd;
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 5rem;
  justify-content: center;
   @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
  gap: 1rem;
}
`;
